import { firstValueFrom, timeout } from 'rxjs';
import { action$, withNamespace, ofType } from '@ardoq/rxbeach';
import { streamInitialized } from '../../actions/navigatorActions';
import { COMPONENT_MOUNT_TIMEOUT_MS } from '../../consts';

export const waitForComponentHierarchyToBeMounted = async (namespace: string) =>
  firstValueFrom(
    action$.pipe(
      withNamespace(namespace),
      ofType(streamInitialized),
      timeout(COMPONENT_MOUNT_TIMEOUT_MS)
    )
  );
